import { prependRoot } from "../../util/prependRoot.js";
import { getApiRoot } from "../../store/configureStore.js";
import axios from "axios";
import httpRequestWrapper from "../../authentication/httpRequestWrapper";

const routePrefix = "/security/";

const SecurityApi = {
    getAuthorizationInfo() {
        const serviceUrl = prependRoot(routePrefix + 'JSGetAuthorization', getApiRoot());
        return axios.get(serviceUrl, {
            headers: {
                'accept': 'application/json'
            }
        });
    },
    switchOrganisation(organisationId) {
        const serviceUrl = prependRoot(routePrefix + `switchorganisation/${organisationId}`, getApiRoot());
        return axios.get(serviceUrl, {
            headers: {
                'accept': 'application/json'
            }
        });
    },
    authorizeSpoVlaMedewerker(accountId, organisatieType) {
        const serviceUrl = prependRoot(routePrefix + `authorizespovlamedewerker/${accountId}/${organisatieType}`, getApiRoot());
        return httpRequestWrapper.get(serviceUrl);
    }
};

export default SecurityApi;
